export default __webpack_public_path__ + "static/media/hot-takes.cef51c8b.svg";